module.exports = __webpack_public_path__ + "static/img/小米淘淘.b759840e.png";